import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-unsaved-changes',
  templateUrl: './unsaved-changes.component.pug',
  styleUrls: ['./unsaved-changes.component.scss'],
  standalone: false
})
export class UnsavedChangesComponent {
  message = ''
  constructor(private bsModel: BsModalRef) {}
  saveTeams() {
    this.message = 'confirm'
    this.bsModel.hide()
  }
  cancel() {
    this.message = 'cancel'
    this.bsModel.hide()
  }
}
